import { useMemo, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { useFuelAutocompleteProps } from '@deere/fuel-react/useFuelAutocompleteProps.js';

export default function MultiSelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
  open = true,
  components
}) {
  let i = 0;
  const [selOptions, setSelOptions] = useState(
    filterValue?.map((val) => ({ key: i++, value: val, label: val })) ?? []
  );

  function optionsSort(a, b) {
    const nameA = a.label?.toUpperCase() ?? '';
    const nameB = b.label?.toUpperCase() ?? '';
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  }

  const options = useMemo(() => {
    const map = new Map();
    preFilteredRows.forEach((row) => {
      const val = row.values[id];
      map.set(val, { key: i++, value: val, label: val });
    });
    selOptions.forEach((data) => map.set(data.value, { ...data }));
    return [...map.values()].sort(optionsSort);
  }, [id, preFilteredRows, selOptions]);

  function handleChange(_, selectedValues) {
    const values = selectedValues ?? [];
    const list = values.map((obj) => obj.value);
    setFilter(list.length ? list : undefined);
    setSelOptions(values);
  }

  const { Dropdown: DropdownWrapper } = components || {};

  const fuelProps = useFuelAutocompleteProps({
    multiple: true,
    slotProps: {
      displayText: {
        renderText: (values) =>
          values.length === 1 ? values[0].label : `${values.length} selected`
      }
    }
  });

  const autocomplete = (
    <Autocomplete
      {...fuelProps}
      options={options}
      value={selOptions}
      onChange={handleChange}
      getOptionLabel={(option) => option.label ?? ''}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      disableCloseOnSelect
      open={DropdownWrapper ? true : open}
      onOpen={() => {}}
      onClose={() => {}}
      disablePortal={!!DropdownWrapper}
      renderInput={(params) => <TextField {...params} />}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
          {option.label}
        </li>
      )}
    />
  );

  if (DropdownWrapper) {
    return <DropdownWrapper>{autocomplete}</DropdownWrapper>;
  }

  return autocomplete;
}
